import Table from '../../components/ui/Table'
import EmptyState from '../../components/ui/EmptyState'
import UserRow from './UserRow'

function UserTable({ users, onUpdateRole, onEdit, onDelete, currentUserId }) {
  if (users.length === 0) {
    return (
      <EmptyState
        icon="👥"
        title="No users yet"
        description="Users will appear here when they sign up"
      />
    )
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header>User</Table.Header>
          <Table.Header>Email</Table.Header>
          <Table.Header>Role</Table.Header>
          <Table.Header>Joined</Table.Header>
          <Table.Header style={{ width: '100px' }}></Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {users.map(user => (
          <UserRow
            key={user.id}
            user={user}
            onUpdateRole={onUpdateRole}
            onEdit={onEdit}
            onDelete={onDelete}
            isCurrentUser={user.id === currentUserId}
          />
        ))}
      </Table.Body>
    </Table>
  )
}

export default UserTable
